import {
    Checkbox,
    FormControlLabel,
    FormGroup,
    Grid,
    IconButton,
    InputAdornment,
    MenuItem,
    TextField,
    Tooltip,
} from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import AttachFileIcon from "@material-ui/icons/AttachFile";
import { DateTimePicker } from "@material-ui/pickers";
import MeditocDateIcon from "../../../utils/MeditocDateIcon";
import MeditocModal from "../../../utils/MeditocModal";
import { useAnuncio } from "../../../../context/AnuncioContext";
import { useCatalogo } from "../../../../context/CatalogoContext";

export default function FormCupon() {
    const { entCatalogos } = useCatalogo();
    const {
        modalOpenFormAnuncio,
        formAnuncio,
        handleOpenFormAnuncio,
        handleChangeFormAnuncioCheck,
        handleChangeFormAnuncioUInt,
        handleChangeFormAnuncioFecha,
        handleClickCargarArchivo,
        handleSubmitFormAnuncio,
    } = useAnuncio();

    const {
        txtCatAnuncio,
        txtFechaInicio,
        txtFechaVencimiento,
        chkFechaInicio,
        chkFechaVencimiento,
        txtDuracion,
        txtArchivo,
    } = formAnuncio;

    return (
        <MeditocModal
            title="Crear anuncio"
            open={modalOpenFormAnuncio}
            setopen={handleOpenFormAnuncio}
            okfunc={handleSubmitFormAnuncio}
            okmessage="Guardar"
            size="small"
            form
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        name="txtCatAnuncio"
                        label={txtCatAnuncio.label}
                        required={txtCatAnuncio.required}
                        value={txtCatAnuncio.value}
                        error={txtCatAnuncio.error}
                        helperText={txtCatAnuncio.error && txtCatAnuncio.message}
                        onChange={handleChangeFormAnuncioUInt}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        select
                    >
                        {entCatalogos.catAnuncios.map((grupo) => (
                            <MenuItem key={grupo.fiId} value={grupo.fiId}>
                                {grupo.fsDescripcion} - Dimenciones:{grupo.iAncho}x{grupo.iAlto} , {grupo.sTipo}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <Grid item xs={12}>
                        <FormGroup row>
                            <FormControlLabel
                                label={chkFechaInicio.label}
                                control={
                                    <Checkbox
                                        name="chkFechaInicio"
                                        checked={chkFechaInicio.value}
                                        onChange={(e) => handleChangeFormAnuncioCheck(e, "chkFechaInicio")}
                                    />
                                }
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        {chkFechaInicio.value === true ? (
                            <DateTimePicker
                                name="txtFechaInicio"
                                label={txtFechaInicio.label}
                                //required={txtFechaInicio.required}
                                value={txtFechaInicio.value}
                                error={txtFechaInicio.error}
                                //helperText={txtFechaInicio.error && txtFechaInicio.message}
                                onChange={(date) => handleChangeFormAnuncioFecha(date, "txtFechaInicio")}
                                views={["year", "month", "date", "hours", "minutes"]}
                                InputProps={{ endAdornment: <MeditocDateIcon /> }}
                                inputVariant={inputVariant}
                                format="dd/MM/yyy hh:mm a"
                                color={inputColor}
                                openTo="year"
                                maxDate={txtFechaInicio.value}
                                disablePast
                                fullWidth
                                autoOk={true}
                            />
                        ) : null}
                    </Grid>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <Grid item xs={12}>
                        <FormGroup row>
                            <FormControlLabel
                                label={chkFechaVencimiento.label}
                                control={
                                    <Checkbox
                                        name="chkFechaVencimiento"
                                        checked={chkFechaVencimiento.value}
                                        onChange={(e) => handleChangeFormAnuncioCheck(e, "chkFechaVencimiento")}
                                    />
                                }
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        {chkFechaVencimiento.value === true ? (
                            <DateTimePicker
                                name="txtFechaVencimiento"
                                label={txtFechaVencimiento.label}
                                //required={txtFechaVencimiento.required}
                                value={txtFechaVencimiento.value}
                                error={txtFechaVencimiento.error}
                                //helperText={txtFechaVencimiento.error && txtFechaVencimiento.message}
                                onChange={(date) => handleChangeFormAnuncioFecha(date, "txtFechaVencimiento")}
                                views={["year", "month", "date", "hours", "minutes"]}
                                InputProps={{ endAdornment: <MeditocDateIcon /> }}
                                inputVariant={inputVariant}
                                format="dd/MM/yyy hh:mm a"
                                color={inputColor}
                                openTo="year"
                                minDate={txtFechaInicio.value}
                                disablePast
                                fullWidth
                                autoOk={true}
                            />
                        ) : null}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtDuracion"
                        label={txtDuracion.label}
                        required={txtDuracion.required}
                        value={txtDuracion.value}
                        error={txtDuracion.error}
                        placeholder={txtDuracion.placeholder}
                        helperText={txtDuracion.error && txtDuracion.message}
                        onChange={handleChangeFormAnuncioUInt}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtArchivo"
                        label={txtArchivo.label}
                        required={txtArchivo.required}
                        value={txtArchivo.value}
                        error={txtArchivo.error}
                        placeholder={txtArchivo.placeholder}
                        helperText={txtArchivo.error && txtArchivo.message}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title="Seleccionar archivo" arrow placement="top">
                                        <IconButton onClick={handleClickCargarArchivo}>
                                            <AttachFileIcon />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
